<template>
  <v-dialog
    v-model="show"
    scrollable
  >
    <v-card>
      <v-card-title>
        All Notifications
        <v-spacer></v-spacer>
        <v-btn
          icon
          @click.prevent="show = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <NotificationItem
          v-for="(notification) in notifications"
          :key="notification.Notification_ID"
          :notification="notification"
          :showAll="true"
          @updated="getNotifications"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { getApiErrorMessage } from '@/utils/apiError'
export default {
  name: 'AllNotifications',
  components: {
    NotificationItem: () => import('@/components/notifications/NotificationItem.vue')
  },
  props: {
    value: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      notifications: ''
    }
  },
  computed: {
    user () {
      return this.$store.getters.getUser
    },
    show: {
      get () {
        if (this.value) {
          this.getNotifications()
        }
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    getNotifications () {
      this.axios.get('/api/all-notifications', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.notifications = res.data
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    }
  }
}
</script>
